import React, {useEffect, useState} from "react";
import useApiCallService from "../../Common/Helpers/ApiCall";
import SortableList from "../../Common/Components/Lists/SortableList";
import {Col, Row} from "reactstrap";
import ResponseDigitalAccountModel from "../Models/Response/ResponseDigitalAccount";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS} from "../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {LoadLocalStorage} from "../../Common/Helpers/LoadLocalStorage";
import {CardDigitalAccount} from "../Components/CardDigitalAccount";
import AdminResponseAttestModel from "../../Attest/Model/Response/AdminResponseAttestModel";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";

export function AdminDigitalAccountList() {
    const { t } = useTranslation();
    const {ApiCall} = useApiCallService();
    const navigate = useNavigate();
    const search = LoadLocalStorage("search");
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();
    
    useEffect(() => {
        setPageTitle(t('adminLabel.digitalAccount'));
        setPageTitleKey('adminLabel.digitalAccount');
        setOnBack(null);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    // API RESPONSES
    const [responseAllDigitalAccount, setResponseAllDigitalAccount] = useState('');

    const [searchValue, setSearchValue] = useState('');
    const [done, setDone] = useState(null);
    const [changedFilter, setChangedFilter] = useState("true");

    useEffect(() => {
        if (search) {
            setSearchValue(search);
            setDone(true);
            localStorage.removeItem('search');
        }
    }, [search]);

    const ResponseCheck = () => {
        setChangedFilter("loading");
        setTimeout(() => {
            setChangedFilter("true");
        }, 500);
    }

    //GET TOTAL DIGITAL ACCOUNT BALANCE
    useEffect(() => {
        if (done === true || done === null) {
            setDone(false);
            const handleAllDigitalAccountResponse = (responseAllAccountRowList) => {
                if (responseAllAccountRowList !== null) {
                    setResponseAllDigitalAccount(responseAllAccountRowList);
                }
            };
            const AllDigitalAccountApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/digital-account/admin/total-all-account?" + searchValue,
                    };
                    await ApiCall(apiCallOptions, handleAllDigitalAccountResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };
            AllDigitalAccountApiCall();
        }

    }, [done]);

    const renderActionColumn = (item) => {
        return (
            <>
                <CustomButton icon = "bx bx-show py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText={t('button.info')} customClasses="rounded" buttonBorder={false} id={item.id} onClick={() => {
                    navigate(`${ADMIN_PATHS.DIGITAL_ACCOUNT_VIEW}?id=${item.id}`);
                }} />
            </>
        );
    }
    const isSuperAdmin = CheckUserRole('SuperAdmin');
    const columns = [
        "visualId",
        "orgName",
        "orgType",
        "costPlace",
        "updatedAt",
        'balance',
    ];

    if (isSuperAdmin === true) {
        columns.unshift('id', 'orgId');
    }

    const listOptions = {
        "model": ResponseDigitalAccountModel,
        'columns': columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": "/digital-account/admin/search/filter",
        "nameFile": t('digitalAccount.label'),
        "ignoreFields" : columns,
        "modelType" : "AdminDigitalAccount",
        "filterTestIsAvailable": true,
        "urlGetSearch" : "/digital-account/admin/search/filter",
        "viewName": "AdminDigitalAccountList"
    };

    const renderActionColumnAttest = (item) => {
            return (
                <>
                    <button className="rounded me-2 py-2 border-0 text-green bg-green-light p-custom-button position-relative class-approve"
                            onClick={() => {
                                navigate(`${ADMIN_PATHS.ATTEST_INFO}?id=${item.id}&from=primary&admindigitalaccount=true`);
                            }} >
                        <i className="bx bx-show pb-custom align-middle size-icon-custom-button" />
                        <div className="tooltip-custom-button">
                            {t('button.info') }
                        </div>
                    </button>
                </>
            );
        }

    const columnsAttest = [
        'createdAt',
        "recipient",
        "orgName",
        "orgType",
        "costPlace",
        "model",
        "modelVisualId",
        "modelStartDate",
        "amount",
        //"status",
    ];


    const listOptionsAttest = {
        "model": AdminResponseAttestModel,
        'columns':columnsAttest,
        "actions": {
            "actionColumn" : renderActionColumnAttest,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": `/attest/admin/search-pending-org-all/filter`,
        "nameFile": t('attest.attest'),
        "modelType" : "Attest",
        "ignoreFields" : [...columnsAttest, "createdByName"],
        "filterTestIsAvailable": true,
        "urlGetSearch" : "/attest/admin/search-pending-org-all/filter",
        "viewName": "AdminAttestPendingOrg",
    };

    return(
       <>
           <Col lg={12}>
               <Row className="pb-5">
                   <Col lg={12} className="mt-4 card-backend p-4">
                       <h2 className='rokkitt-font'>{t('adminLabel.digitalAccount')}</h2>
                       {/* <Row>
                           <Col lg={4}>
                               <CardDigitalAccount data={responseAllDigitalAccount} label={searchValue} displayValue={changedFilter} />
                           </Col>
                       </Row> */}
                       {/* <Col lg={12} className="mt-4 card-backend p-4">
                                                   <h2 className="fw-bold rokkitt-font">Händelser som ligger framåt </h2>
                                                   <SortableList
                                                       listOptions={listOptionsAttest}
                                                   />
                                               </Col> */}
                       <SortableList listOptions={listOptions} onResponse={ResponseCheck} />
                   </Col>
               </Row>
           </Col>
       </>
    );
}